import React, { useState, useEffect } from 'react';
import { getBuyRate } from '../../services/proptService';

const CryptoStep2 = ({ setCurrentStep, purchaseData, setRateData, cryptoType }) => {
   console.log('CryptoStep2: He recibido estos datos:', purchaseData);
   const [localRateData, setLocalRateData] = useState(null);
   const [isLoading, setIsLoading] = useState(true);
   const [apiError, setApiError] = useState('');
   const [showInUsd, setShowInUsd] = useState(false);

   const handleToggleView = () => {
      setShowInUsd(prev => !prev);
   };

   useEffect(() => {

      const fetchRate = async () => {
         // Guarda de seguridad: nos aseguramos de tener un valor en USD para enviar
         if (!purchaseData.usdEquivalent || purchaseData.usdEquivalent <= 0) return;

         setIsLoading(true);
         setApiError('');
         setLocalRateData(null);
         try {
            // Creamos los parámetros que la API SÍ entiende
            const currencyForAPI = cryptoType?.currency || 'PROPT'; // 'PROPT' como fallback
            console.log(cryptoType.currency)
            const params = {
               invoice_currency: 'USD', // Siempre enviamos USD
               invoice_amount: purchaseData.usdEquivalent, // Enviamos el monto equivalente en USD
               currency: currencyForAPI,
               // payment_source: purchaseData.sourceCurrency, // Indicamos la crypto de origen
               payment_source: 'crypto', // Indicamos la crypto de origen
            };

            const data = await getBuyRate(params);
            // console.log('CryptoStep2: Respuesta RECIBIDA de la API:', data);
            console.log("1. GetBuyRate -> Enviando Params:", params);

            if (data && data.err) {
               throw new Error(data.err);
            }
            setLocalRateData(data);
            setRateData(data);

         } catch (error) {
            console.error("Error fetching rate data", error);
            setApiError(error.message || "An unexpected error occurred. Please try again.");
         } finally {
            setIsLoading(false);
         }
      };
      fetchRate();

   }, [purchaseData, setRateData]);


   if (isLoading) {
      return <div className="modal_content_body px-4 text-center"><h4>Calculating rates...</h4></div>;
   }

   if (apiError) {
      return (
         <div className="modal_content_body px-4 text-center">
            <h4 className="text-danger">Error</h4>
            <p className="mb-4">{apiError}</p>
            <p className="text-muted">This may be due to a high purchase amount. Please try a smaller amount.</p>
            <button
               className="ppt_btn_primary alt"
               onClick={() => setCurrentStep(1)} // Botón para volver al paso anterior
            >
               Go Back
            </button>
         </div>
      );
   }


   if (!localRateData) {
      return <div className="modal_content_body px-4 text-center"><h4>Could not retrieve rate information.</h4></div>;
   }

   return (
      <div className="modal_content_body px-4">
         <div className="withdraw-crypto-form">
            <h3 className="ppt_form_title mb-4 text-center">Crypto payment by <img src={process.env.PUBLIC_URL + '/assets/img/logo_fpay.svg'} alt="" className='ps-2' /></h3>
            <div className="w-100" style={{ backgroundColor: '#f3f3f3', borderRadius: '15px', padding: '24px' }}>
               <div className="d-flex justify-content-end mb-3">
                  <div className="d-flex align-items-center gap-2" onClick={handleToggleView} style={{ cursor: 'pointer' }}>
                     <svg width="22" height="22" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_229_16618)">
                           <path d="M44.1498 16.8444C44.6388 17.2443 44.7105 17.9641 44.3109 18.4527L24.3491 42.8595L31.2539 42.1678C31.8824 42.1048 32.4422 42.5627 32.5049 43.191C32.5364 43.505 32.4376 43.8022 32.2526 44.0285C32.0675 44.2548 31.7958 44.4105 31.4817 44.442L21.8315 45.4088C21.203 45.4718 20.6432 45.0139 20.5805 44.3856L19.6137 34.7354C19.5507 34.1069 20.0086 33.5471 20.6369 33.4843C21.2651 33.4216 21.8252 33.8792 21.8879 34.5075L22.5796 41.4123L42.5414 17.0055C42.941 16.5169 43.6607 16.4444 44.1498 16.8444ZM30.9257 6.46133L21.2755 7.42814C20.647 7.4911 20.1891 8.05093 20.2523 8.67918C20.3154 9.30743 20.8751 9.76552 21.5033 9.70237L28.408 9.01063L8.4463 33.4174C8.04668 33.906 8.11838 34.6258 8.60743 35.0258C9.09648 35.4258 9.81618 35.3532 10.2158 34.8646L30.1775 10.4579L30.8693 17.3626C30.9323 17.9911 31.4921 18.4489 32.1203 18.3858C32.4344 18.3543 32.7061 18.1986 32.8912 17.9723C33.0762 17.746 33.175 17.4488 33.1435 17.1348L32.1767 7.48453C32.114 6.85624 31.5539 6.39819 30.9257 6.46133Z" fill="black"></path>
                        </g>
                        <defs>
                           <clipPath id="clip0_229_16618">
                              <rect width="36.5755" height="36.5755" fill="white" transform="translate(0.644531 28.5132) rotate(-50.721)"></rect>
                           </clipPath>
                        </defs>
                     </svg>
                     <span style={{ fontWeight: '500' }}>
                        {showInUsd ? `Show in ${purchaseData.sourceCurrency}` : 'Show in USD'}
                     </span>
                  </div>
               </div>

               <div className="mb-2">
                  <div className="d-flex justify-content-between align-items-center">
                     <span style={{ fontWeight: '600' }}>You pay</span>
                     <span>
                        {showInUsd
                           ? `$${purchaseData.usdEquivalent.toFixed(2)} USD`
                           : `${parseFloat(purchaseData.sourceAmount).toFixed(8)} ${purchaseData.sourceCurrency}`
                        }
                     </span>
                  </div>
               </div>

               <div className="mb-2">
                  <div className="d-flex justify-content-between align-items-center">
                     <span style={{ fontWeight: '500' }}>Exchange Rate</span>
                     <small>1 USD = {parseFloat(localRateData.rate).toFixed(4)} {localRateData.currency.startsWith('PROPT') ? ' PROPT' : ` ${localRateData.currency}`}</small>
                  </div>
               </div>

               <hr style={{ margin: '10px 0' }} />

               <div className="mb-2">
                  <div className="d-flex justify-content-between align-items-center">
                     <span style={{ fontWeight: '600' }}>You get (subtotal)</span>
                     <span>{parseFloat(localRateData.amount_exchange).toFixed(4)} {localRateData.currency.startsWith('PROPT') ? ' PROPT' : ` ${localRateData.currency}`}</span>
                  </div>
               </div>
               <div className="mb-2">
                  <div className="d-flex justify-content-between align-items-center text-danger">
                     <span style={{ fontWeight: '500' }}>Less: Processing Fee</span>
                     <span>- {parseFloat(localRateData.network_processing_fee).toFixed(4)} {localRateData.currency.startsWith('PROPT') ? ' PROPT' : ` ${localRateData.currency}`}</span>
                  </div>
               </div>

               {localRateData.fast_transaction_fee && !isNaN(localRateData.fast_transaction_fee) && (
                  <div className="mt-3 mb-4 text-muted">
                     <div className="d-flex justify-content-between align-items-center">
                        <small style={{ fontWeight: '500' }}>+ Additional Gas Fee</small>
                        <small>{parseFloat(localRateData.fast_transaction_fee).toFixed(4)} {localRateData.fast_transaction_fee_currency}</small>
                     </div>
                  </div>
               )}

               <hr style={{ margin: '10px 0' }} />

               <div className="mb-2">
                  <div className="d-flex justify-content-between align-items-center">
                     <span style={{ fontWeight: '700', fontSize: '1.1rem' }}>Total to Receive</span>
                     <span style={{ fontWeight: '700', fontSize: '1.1rem' }}>{parseFloat(localRateData.amount).toFixed(4)} {localRateData.currency.startsWith('PROPT') ? ' PROPT' : ` ${localRateData.currency}`}</span>
                  </div>
               </div>


               <div className="text-center mb-4">
                  <div>
                     <span style={{ color: '#ff3333', fontWeight: '600' }}>Warning:</span>
                     <span> Crypto transactions are final.</span>
                  </div>
               </div>
               <div className="d-flex justify-content-center">
                  <button
                     className="ppt_btn_primary alt"
                     onClick={() => setCurrentStep(3)}
                  >
                     Continue
                  </button>
               </div>

            </div>
         </div>
      </div>
   );
};
export default CryptoStep2;